export const MAX_LEN_QUESTION_TEXT = 200;
export const MAX_LEN_QUESTION_MEDIA_CAPTION = 150;
